export default __webpack_public_path__ + "static/media/planticon_1.709647ce.png";